import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { EDIT_NOTIFICATION_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';
import { RecipientSelection } from '../manage-announcements/useGetAnnouncementDetails';

// =============================================================================
// Request & Response Model
// =============================================================================
export interface NotificationRecipientSelectRequesteContentObject {
  userUuid: string;
  nricFinPassport: string;
  name: string;
  indexNo: string;
  examCentre: string;
  emailMobile: string;
}

export interface NotificationRecipientSelection extends RecipientSelection {
  recipients: NotificationRecipientSelectRequesteContentObject[];
}

interface EditNotificationRequest {
  title: string;
  message: string;
  ackRequired: boolean;
  sendDate: string;
  notificationType: string;
  recipientSelection: NotificationRecipientSelection;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

export const usePutEditNotification = ({ onSuccess, onError, uuid }: Input) => {
  const putEditNotification = async (requestData: EditNotificationRequest) => {
    const res = await axiosClient.put<void>(EDIT_NOTIFICATION_URL(uuid), requestData);
    return res.data;
  };

  return useCustomMutation(putEditNotification, {
    onSuccess,
    onError,
  });
};
